/**
 * Subscription Plans
 * @see components/subscription/Table.vue
 */
export const SUBSCRIPTION_COLUMNS = [
    {
        name: 'title',
        label: 'Baslik',
        field: 'title',
        align: 'left',
    },
    { name: 'price', label: 'Fiyat (TL)', field: 'price', align: 'left' },
    {
        name: 'regional_loss',
        label: 'Bolgesel Zayiflama (Adet)',
        field: 'regional_loss',
        align: 'left',
    },
    {
        name: 'regime_session',
        label: 'Diyet Seansi (Adet)',
        field: 'regime_session',
        align: 'left',
    },
    {
        name: 'actions',
        label: 'Aksiyonlar',
        field: 'regime_session',
        align: 'left',
    },
]

/**
 * Customer 
 * @see components/customer/Table.vue
 */
export const CUSTOMER_COLUMNS = [
    {
        name: 'name',
        label: 'Isim ve Soyisim',
        field: 'name',
        align: 'left',
    },
    {
        name: 'gender',
        label: 'Cinsiyet',
        field: 'gender',
        align: 'left',
    },
    { name: 'email', label: 'E-Posta Adresi', field: 'email', align: 'left' },
    {
        name: 'phone',
        label: 'Telefon Numarasi',
        field: 'phone',
        align: 'left',
    },
    {
        name: 'medical',
        label: 'Medikal Uyarilar',
        field: 'medical',
        align: 'left',
    },
    {
        name: 'activeSubscriptions',
        label: 'Aktif Paketler',
        field: 'activeSubscriptions',
        align: 'left',
    },
    {
        name: 'actions',
        label: 'Aksiyonlar',
        field: 'actions',
        align: 'left',
    },
]

/**
 * Payment
 * @see component/payments/Table.vue
 */
export const PAYMENT_COLUMNS = [
    {
        name: 'timestamp',
        label: 'Tarih',
        field: 'timestamp',
        align: 'left',
    },
    {
        name: 'subscriptionTitle',
        label: 'Paket',
        field: 'subscriptionTitle',
        align: 'left',
    },
    {
        name: 'price',
        label: 'Tutal (TL)',
        field: 'price',
        align: 'left',
    },
    {
        name: 'type',
        label: 'Odeme Tipi',
        field: 'type',
        align: 'left',
    },
]